import styled from 'styled-components'

export const Wrapper = styled.div`
text-align: center;
padding: 3rem 1rem;

h2 {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 2rem;
}

.sub-header-text {
    max-width: 680px;
    margin: 0 auto 2rem;
    color: #555;
    font-size: 0.95rem;
    line-height: 1.45;
}

.plans-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 2rem;
}

.plan {
    background: white;
    padding: 1.2rem;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 90%;
    max-width: 330px;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transition: all 0.3s ease;
    cursor: pointer;
    height: 100%;
}
.point:hover {
   transform: scale(1.02);
}    

h3 {
    font-size: 1.4rem;
    font-weight: bold;
    margin-bottom: -1rem;
}

.price-container {
    display: flex;
    align-items: baseline;
    justify-content: left;
    margin-bottom: 0.1rem;
}
 .highlight {
        border: 2px solid #007bff;
        box-shadow: 0px 0px 15px rgba(0, 123, 255, 0.4);
}
.highligt-pro {
    border: 2px solid #27AE60;
    box-shadow: 0px 0px 15px rgba(11, 144, 49, 0.4);
}

.price {
    font-size: 2rem; /* Increased size for better visibility */
    font-weight: bold;
    margin-right: 3px;
}

.price span {
    font-size: 1.2rem;
    color: #666;
}

ul {
    list-style: none;
    padding: 0;
    margin-top: -0.5rem;
    text-align: left;
    width: 100%;
    max-width: 260px;
}

li {
    font-size: 1.1rem; /* Slightly bigger text for better readability */
    padding: 0.1rem 0;
    display: flex;
    align-items: center;
}

button {
    background: #007bff;
    color: white;
    border: none;
    padding: 0.7rem;
    cursor: pointer;
    margin-top: auto;
    width: 100%;
    border-radius: 6px;
    font-size: 1rem;
    font-weight: bold;
}

 .check-icon {
        font-size: 1.2rem;
        margin-right: 5px;
    }

    .basic-check .check-icon {
        color: #007bff; /* Blue check for Basic */
    }

    .pro-check .check-icon {
        color: #27AE60; /* Green check for Pro */
    }

.pro-btn {
    background: #27AE60 /* Softer orange, friendlier color */
}

.disabled-card {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}

button:hover {
    opacity: 0.85;
}

/* Responsive Design */
@media (max-width: 768px) {
    .plans-container {
        flex-direction: column;
        align-items: center;
        gap: 1rem;
    }

    .plan {
        width: 100%;
        max-width: 90%;
    }

    h2 {
        font-size: 1.6rem;
        margin-bottom: 1.25rem;
    }

    .sub-header-text {
        font-size: 0.9rem;
        margin-bottom: 1.75rem;
        padding: 0 0.25rem;
    }
}
`;